<template>
  <div class="page donation-page">
    <h2 class="page-title">捐赠与众筹管理</h2>
    <div class="filter-card">
      <el-form :model="query" size="small" label-width="68px" class="filter-form">
        <el-row :gutter="12">
          <el-col :xl="5" :lg="6" :md="8" :sm="12" :xs="24"><el-form-item label="泉井名称"><el-input v-model="query.wellName" placeholder="搜索泉井名称" clearable /></el-form-item></el-col>
          <el-col :xl="4" :lg="6" :md="8" :sm="12" :xs="24">
            <el-form-item label="状态">
              <el-select v-model="query.status" clearable placeholder="全部">
                <el-option label="待审核" :value="0" /><el-option label="已公示" :value="1" /><el-option label="已拒绝" :value="2" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xl="5" :lg="6" :md="8" :sm="12" :xs="24"><el-form-item label="捐赠人"><el-input v-model="query.keyword" placeholder="昵称/电话" clearable /></el-form-item></el-col>
          <el-col :xl="4" :lg="6" :md="8" :sm="12" :xs="24">
            <el-form-item class="filter-actions">
              <el-button type="primary" @click="handleSearch">查询</el-button>
              <el-button @click="handleReset">重置</el-button>
              <el-button @click="exportList">导出</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-card">
      <el-table :data="tableData" v-loading="loading" border>
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column prop="wellName" label="泉井名称" min-width="140" show-overflow-tooltip />
        <el-table-column label="捐赠人" min-width="180">
          <template slot-scope="scope">
            <div class="user-cell">
              <el-avatar :size="36" :src="scope.row.avatarUrl" icon="el-icon-user-solid" />
              <div>
                <div class="main-text">{{ scope.row.nickname || scope.row.donorName || '-' }}</div>
                <div class="sub-text">{{ scope.row.phone || '-' }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="amount" label="捐赠金额(元)" width="120" />
        <el-table-column label="捐赠方向" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">{{ directionText(scope.row.direction) }}</template>
        </el-table-column>
        <el-table-column prop="message" label="留言" min-width="160" show-overflow-tooltip />
        <el-table-column label="状态" width="100">
          <template slot-scope="scope"><el-tag :type="statusType(scope.row.auditStatus)">{{ statusText(scope.row.auditStatus) }}</el-tag></template>
        </el-table-column>
        <el-table-column label="备注" min-width="180">
          <template slot-scope="scope">
            <div class="remark-cell">
              <el-input
                v-if="editingRemarkId === scope.row.id"
                v-model="editingRemark"
                size="mini"
                class="remark-input"
                @blur="saveRemark(scope.row)"
                @keyup.enter.native="saveRemark(scope.row)"
                placeholder="输入备注后回车或失焦保存"
                autofocus
              />
              <span v-else class="remark-text" @click="startEditRemark(scope.row)">
                {{ scope.row.auditRemark || '点击输入备注' }}
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="申请时间" width="160"><template slot-scope="scope">{{ formatDateTime(scope.row.createdAt) }}</template></el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <div class="action-bar">
              <span class="action-text view" @click="handleView(scope.row)">查看</span>
              <span v-if="scope.row.auditStatus === 0" class="action-text pass" @click="handlePass(scope.row)">通过公示</span>
              <span v-if="scope.row.auditStatus === 0" class="action-text reject" @click="handleReject(scope.row)">拒绝</span>
              <span class="action-text delete" @click="handleDelete(scope.row)">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next, total" :total="total" :current-page.sync="query.pageNum" :page-size="query.pageSize" @current-change="loadData" style="margin-top:16px;text-align:right" />
    </div>

    <!-- 查看详情弹窗 -->
    <el-dialog title="捐赠详情" :visible.sync="viewVisible" width="500px">
      <el-descriptions v-if="viewRow" :column="2" border size="small">
        <el-descriptions-item label="泉井名称" :span="2">{{ viewRow.wellName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="捐赠人">{{ viewRow.nickname || viewRow.donorName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="联系电话">{{ viewRow.phone || '-' }}</el-descriptions-item>
        <el-descriptions-item label="捐赠金额">{{ viewRow.amount }} 元</el-descriptions-item>
        <el-descriptions-item label="捐赠方向">{{ directionText(viewRow.direction) }}</el-descriptions-item>
        <el-descriptions-item label="留言" :span="2">{{ viewRow.message || '无' }}</el-descriptions-item>
        <el-descriptions-item label="状态"><el-tag :type="statusType(viewRow.auditStatus)">{{ statusText(viewRow.auditStatus) }}</el-tag></el-descriptions-item>
        <el-descriptions-item label="备注">{{ viewRow.auditRemark || '无' }}</el-descriptions-item>
        <el-descriptions-item label="申请时间" :span="2">{{ formatDateTime(viewRow.createdAt) }}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer"><el-button @click="viewVisible = false">关闭</el-button></span>
    </el-dialog>

    <!-- 拒绝弹窗 -->
    <el-dialog title="拒绝捐赠" :visible.sync="rejectVisible" width="420px">
      <el-form :model="rejectForm" label-width="80px">
        <el-form-item label="拒绝原因">
          <el-input v-model="rejectForm.remark" type="textarea" :rows="3" placeholder="请填写拒绝原因（将保存为备注）" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="rejectVisible = false">取消</el-button>
        <el-button type="danger" @click="submitReject">确认拒绝</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { fetchDonations, auditDonation, updateDonationRemark, deleteDonation } from '@/api'

const DIRECTION_MAP = {
  1: '认领一个泉井一年的水质检测费用1000元',
  2: '支持泉井守护者一年的巡护和维护费用2000元',
  3: '认领一个泉井的修缮改造费用（2000至20000元不等）',
  4: '支持泉井地图的开发和运营，保护全国范围更多泉井'
}

export default {
  data() {
    return {
      loading: false,
      tableData: [], total: 0,
      query: { pageNum: 1, pageSize: 10, wellName: '', keyword: '', status: undefined },
      viewVisible: false, viewRow: null,
      rejectVisible: false, rejectForm: { id: null, remark: '' },
      editingRemarkId: null, editingRemark: ''
    }
  },
  watch: {
    'query.wellName'() { this.handleSearch() },
    'query.keyword'() { this.handleSearch() },
    'query.status'() { this.handleSearch() }
  },
  created() { this.loadData() },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const params = { ...this.query }
        Object.keys(params).forEach(k => { if (params[k] === '' || params[k] === null || params[k] === undefined) delete params[k] })
        const res = await fetchDonations(params)
        this.tableData = res.records || []; this.total = res.total || 0
      } finally { this.loading = false }
    },
    handleSearch() { this.query.pageNum = 1; this.loadData() },
    handleReset() { this.query = { pageNum: 1, pageSize: 10, wellName: '', keyword: '', status: undefined }; this.loadData() },
    handleView(row) { this.viewRow = row; this.viewVisible = true },
    async handlePass(row) {
      try {
        await this.$confirm(`确认通过公示「${row.nickname || row.donorName}」的捐赠 ${row.amount} 元？通过后将在小程序展示。`, '通过公示', { confirmButtonText: '确认通过', cancelButtonText: '取消', type: 'success' })
        await auditDonation({ id: row.id, status: 1, remark: row.auditRemark || '' })
        this.$message.success('已通过公示，将在小程序展示')
        this.loadData()
      } catch (e) {}
    },
    handleReject(row) {
      this.rejectForm = { id: row.id, remark: '' }
      this.rejectVisible = true
    },
    async submitReject() {
      await auditDonation({ id: this.rejectForm.id, status: 2, remark: this.rejectForm.remark })
      this.$message.success('已拒绝')
      this.rejectVisible = false
      this.loadData()
    },
    startEditRemark(row) {
      this.editingRemarkId = row.id
      this.editingRemark = row.auditRemark || ''
    },
    async saveRemark(row) {
      if (this.editingRemarkId !== row.id) return
      try {
        await updateDonationRemark({ id: row.id, remark: this.editingRemark })
        row.auditRemark = this.editingRemark
        this.$message.success('备注已保存')
      } catch (e) {
        this.$message.error('保存失败')
      } finally {
        this.editingRemarkId = null
      }
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确认删除该捐赠记录？', '删除确认', { type: 'warning' })
        await deleteDonation(row.id); this.$message.success('已删除'); this.loadData()
      } catch (e) {}
    },
    exportList() {
      const h = ['ID', '泉井名称', '捐赠人', '电话', '金额(元)', '捐赠方向', '留言', '状态', '备注', '申请时间']
      const r = this.tableData.map(row => [row.id, row.wellName, row.nickname || row.donorName, row.phone, row.amount, this.directionText(row.direction), row.message, this.statusText(row.auditStatus), row.auditRemark, this.formatDateTime(row.createdAt)])
      const csv = [h, ...r].map(items => items.map(v => '"' + String(v == null ? '' : v).replace(/"/g, '""') + '"').join(',')).join('\n')
      const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a'); link.href = URL.createObjectURL(blob); link.download = '捐赠记录_' + new Date().toISOString().slice(0, 10) + '.csv'; link.click(); URL.revokeObjectURL(link.href)
    },
    formatDateTime(v) { return v ? String(v).replace('T', ' ') : '-' },
    statusText(v) { return v === 0 ? '待审核' : v === 1 ? '已公示' : v === 2 ? '已拒绝' : '未知' },
    statusType(v) { return v === 1 ? 'success' : v === 2 ? 'danger' : 'warning' },
    directionText(v) { return DIRECTION_MAP[v] || (v ? '方向' + v : '-') }
  }
}
</script>

<style scoped>
.filter-form ::v-deep .el-row { width: 100%; }
.filter-form ::v-deep .el-form-item { margin-bottom: 12px; }
.filter-form ::v-deep .el-input, .filter-form ::v-deep .el-select { width: 100%; }
.filter-form ::v-deep .filter-actions .el-form-item__content { display: flex; gap: 8px; }
.user-cell { display: flex; align-items: center; gap: 10px; }
.main-text { color: #333; font-weight: 600; line-height: 20px; }
.sub-text { color: #909399; font-size: 12px; line-height: 18px; }
.action-bar { display: flex; align-items: center; flex-wrap: wrap; gap: 4px 10px; }
.action-text { cursor: pointer; font-size: 13px; }
.action-text:hover { text-decoration: underline; }
.action-text.view { color: #606266; }
.action-text.pass { color: #2f8f5b; }
.action-text.reject { color: #e6a23c; }
.action-text.delete { color: #f56c6c; }
.remark-cell { min-width: 0; }
.remark-text { cursor: pointer; color: #606266; font-size: 13px; display: block; }
.remark-text:hover { color: #409eff; text-decoration: underline; }
.remark-input { width: 100%; }
.el-pagination { margin-top: 16px; text-align: right; }
</style>
